import { useQuery } from "@tanstack/react-query";
import { getBook } from "../api/client";
import { queryKeys } from "./queryKeys";

export function useBook(id: string | undefined) {
  return useQuery({
    queryKey: queryKeys.book(id ?? ""),
    queryFn: () => getBook(id as string),
    enabled: !!id,
  });
}
